import type { ErrorEvent } from '@sentry/react';

const LANGUAGE_TOOL_TIMEOUTS = [
  'appSettingsDistributor.getValue',
  'predictionDistributor.getValue',
  'dictateStateDistributor.getValue',
  'availableLanguagesDistributor.getValue',
  'availableTextCheckLanguagesDistributor.getValue',
  'lettersVoicesDistributor.getValue',
  'textCheckersDistributor.getValue',
  'dictionariesDistributor.getValue',
  'userDistributor.getValue',
  'speechVoicesDistributor.getValue',
  'topicsDistributor.getValue',
  'nn-NO_wordsDistributor.getValue',
  'nb-NO_wordsDistributor.getValue',
  'fr_wordsDistributor.getValue',
  'ua_wordsDistributor.getValue',
  'ac_wordsDistributor.getValue',
  'en_wordsDistributor.getValue',
  'de_wordsDistributor.getValue',
  'es_wordsDistributor.getValue',
  'ru_wordsDistributor.getValue',
  'getDictionariesByLanguageId',
  'isMathOcrAvailable',
  'isDictateAvailable',
  'isPredictionAvailable',
  'DefineExpirationForLanguagePacks.getValue',
].map((operation) => `Request timeout ${operation}`);

const KNOWN_EXTENSION_REJECTIONS = new Set([
  ...LANGUAGE_TOOL_TIMEOUTS,
  'Invalid call to runtime.sendMessage(). Tab not found.',
  'Invalid call to browser.storage.local.set(). Exceeded storage quota.',
]);

export function shouldIgnoreBrowserRejection(event: ErrorEvent, userAgent: string): boolean {
  const exceptions = event.exception?.values ?? [];
  if (exceptions.length !== 1) return false;

  const rejection = exceptions[0];
  if (rejection.mechanism?.type !== 'auto.browser.global_handlers.onunhandledrejection')
    return false;
  if (rejection.stacktrace?.frames?.length) return false;

  const message = (rejection.value ?? '').replace(
    /^Non-Error promise rejection captured with value: /,
    ''
  );
  if (KNOWN_EXTENSION_REJECTIONS.has(message)) return true;

  const isGoogleOnIos = /(?:iPhone|iPad|iPod)/.test(userAgent) && /(?:CriOS|GSA)\//.test(userAgent);
  return message === 'La' && isGoogleOnIos;
}
